import { render, staticRenderFns } from "./ProfiloUfficioAttivo.vue?vue&type=template&id=3d4c226e&"
import script from "./ProfiloUfficioAttivo.vue?vue&type=script&lang=js&"
export * from "./ProfiloUfficioAttivo.vue?vue&type=script&lang=js&"
import style0 from "./ProfiloUfficioAttivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports